import React, { PureComponent } from 'react';

import { MultiSelectFilter, SelectTypes } from 'common/components/core/select';

export default class FuelTypeFilterComponent extends PureComponent {
    onChange = ({ values: options, allowEmptyOrNull }) => {
        // adding logic for multiselect and special handling for (BLANKS) case.
        const values = options.map(value => this.getOptionValue(value));
        // on clear selection
        if (!values.length && !allowEmptyOrNull) {
            this.props.onChange();
            return;
        }

        this.props.onChange({ values, allowEmptyOrNull });
    };

    getOptionValue = option => option.value;

    getOptionLabel = option => option.label;

    render() {
        const { value, ...rest } = this.props;
        return (
            <MultiSelectFilter
                {...rest}
                selectType={SelectTypes.Outline}
                value={value?.values || []}
                allowEmptyOrNull={value?.allowEmptyOrNull || false}
                onChange={this.onChange}
            />
        );
    }
}
